import styled from '@emotion/styled';
import { IconButton } from '@mui/material';
import type { CSSProperties, ReactNode } from 'react';
import type { SyntheticListenerMap } from '@dnd-kit/core/dist/hooks/utilities';
import type { DraggableAttributes } from '@dnd-kit/core';
import { DotsSixVertical } from '@phosphor-icons/react';

export type CheckboxWrapperProps = {
  styles?: CSSProperties;
  children: ReactNode;
  hasIcon?: boolean;
  listeners?: SyntheticListenerMap | undefined;
  attributes?: DraggableAttributes;
};

export const CheckboxWrapper = ({
  styles,
  attributes,
  listeners,
  hasIcon = true,
  children,
}: CheckboxWrapperProps) => {
  return (
    <Container className="checkboxWrapper" style={{ ...styles }}>
      {hasIcon ? (
        <IconButton
          {...attributes}
          {...listeners}
          sx={{ color: '#000', width: '16px', height: '16px', padding: 0 }}
        >
          <DotsSixVertical data-testid="dots_six_vertical" data-size="16" size={16} />
        </IconButton>
      ) : (
        <div
          className="hiddenDotsSixVertical"
          style={{ width: '16px', height: '16px', padding: 0 }}
        />
      )}
      <span
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          minWidth: 0,
          justifyContent: 'space-between',
          flexDirection: 'row-reverse',
        }}
      >
        {children}
      </span>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-width: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0.5rem;
  height: 28px;
  font-weight: 600;
  gap: 4px;
  svg {
    visibility: hidden;
  }
  :hover {
    svg {
      visibility: visible;
    }
  }
  .MuiSwitch-root {
    margin: 0;
  }
`;
